<template lang="pug"> 
  v-select(
    v-model='selectItem'
    outlined
    dense
    return-object
    hide-details="auto"
    item-text='name'
    :label="$t('label.choose-set-number')" 
    require 
    :items='items'
    :rules="rules"
  )
</template>

<script>
import { numberTemplate as apiNumberTemplate } from '@/apis'
export default {

  props : {
    value:{
      type:Object,
      default : function (){
        return {}
      }
    }, 
    rules:{
      type:Array,
      default: () => []
    }
  },

  data: () => ({ 
    selectItem :null,
    items : []
  }), 

  watch: {
    selectItem (val) {
      this.$emit('input',val)
    }
  },

  async mounted () {
    await this.load ()
  }, 

  methods : {  
    async load () {
      const [err,data] = await apiNumberTemplate.getNumberType()
      if(err){
        return
      }

      this.items = data  
    }, 
  }
}
</script>